import { type UserRole } from '@common/clients/api';
import { UserRoleIcon } from '@web/atoms/UserRoleIcon';
import styles from '@web/molecules/SimpleComment/SimpleComment.module.scss';

import { CommentHeader } from './CommentHeader';

export interface Props {
    classes?: string;
    userLikeCount?: number;
    reactionTxt?: string;
    role?: UserRole;
    userName: string;
}

export const CommentCard = ({ classes, userLikeCount, reactionTxt, role, userName }: Props) => (
    <div className={`${classes} ${styles['reply-card']}`}>
        <CommentHeader
            userName={userName}
            userLikeCount={Number(userLikeCount)}
            AuthorIcon={role ? <UserRoleIcon role={role} /> : null}
        />
        <p className={styles['reply-content']}>{reactionTxt}</p>
    </div>
);
